// TODO: 1 magyaron is így
var shop_domain = window.origin;

$(document).ready(function () {
    /*setTimeout(function () {
        $.fn.matchHeight._update();
    }, 1000);*/
    $('body').on('contextmenu','img', function(e){
        return false;
    });
    var $empty = $('.empty-val-input input');
    $empty.on('input', function () {

        if (!$.trim(this.value).length) {
            $(this).closest('.empty-val-input').find('label, .placeholder').removeClass('is-visible active');
        } else {
            $(this).closest('.empty-val-input').find('label,  .placeholder').addClass('is-visible active');
        }
    });


    $empty.on('focus', function () {

        if (!$.trim(this.value).length) {
            $(this).closest('.empty-val-input').find('label,  .placeholder').addClass('is-visible active');
        }
    });
    $empty.on('blur', function () {

        if (!$.trim(this.value).length) {
            $(this).closest('.empty-val-input').find('label,  .placeholder').removeClass('is-visible active');
        }
    });
});

var delay = (function () {
    var timer = 0;
    return function (callback, ms) {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
    };
})();

function getParameterByName(name, url) {


    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function getUrlVars() {
    var vars = {};
    var parts = window.location.href.split('?');

    parts.forEach(function(value, key) {
        if (0 < key) {
            var get_params = value.split('&');
            get_params.forEach(function(get_param) {
                var get_param_val = get_param.split('=');
                vars[get_param_val[0]] = get_param_val[1];
            });
        }
    });

    return vars;
}


function zipDecode(zipInput, cityInput) {

    var $zipInput = $(zipInput),
        $cityInput = $(cityInput),
        loader = "<div class='loader-spin'></div>";
    zip = $zipInput.val(),
        country = 'hu',
        url = 'https://api.zippopotam.us/hu/' + zip;
    isLoading = true;
    $cityInput.attr('disabled', 'disabled');

    $cityInput.after(loader);

    var xhr = $.getJSON(url);


    xhr.then(function (data) {


        if (data) {

            $cityInput.val(data.places[0]["place name"]);
            $cityInput.trigger('input');
        }
    })

    xhr.always(function () {
        $('.loader-spin').remove();
        $cityInput.removeAttr('disabled');
    })


}


$(function ($) {


    /*   if ($('body').hasClass('template-index')) {


     var num = $('#countup').html();
     var options = {
     useEasing: true,
     useGrouping: true,
     separator: '',
     decimal: '',
     prefix: '',
     suffix: ''
     };
     var count = new CountUp("countup", 0, num, 0, 10, options);

     var waypoints = $('#home-signup').waypoint({
     handler: function (direction) {
     count.start();
     },
     offset: '75%'
     })


     }*/

});


function getVatCategory(product) {
    var vat = 1;
    if (product.tags.indexOf("vat-category-5") >= 1) vat = 1;
    if (product.tags.indexOf("vat-category-18") >= 1) vat = 1;
    if (product.tags.indexOf("vat-category-27") >= 1) vat = 1;

    return vat;
}


//Árfigyelő position

$(function () {
    timber.productCatalogPage = function (options) {
        var moneyFormat = options.money_format,
            variant = options.variant,
            selector = options.selector,
            product = options.product
        ;


        // Selectors
        var $productImage = $('#productModal').find('#ProductPhotoImg'),
            $addToCart = $('#productModal').find('#AddToCart'),
            $productTitle = $('#productModal').find('#productTitle'),
            $productPrice = $('#productModal').find('#ProductPrice'),
            $comparePrice = $('#productModal').find('#ProductPriceBefore'),
            $quantityElements = $('#productModal').find('.quantity-selector, label + .js-qty'),
            $addToCartText = $('#productModal').find('#AddToCartText');


        if (variant) {

            // Update variant image, if one is set
            if (variant.featured_image) {
                var newImg = variant.featured_image,
                    el = $productImage[0];
                Shopify.Image.switchImage(newImg, el, timber.switchImage);
            }

            // Select a valid variant if available
            if (variant.available) {
                // Available, enable the submit button, change text, show quantity elements
                $addToCart.removeClass('disabled').prop('disabled', false);
                $addToCartText.html("Kosárba");
                $quantityElements.show();
            } else {
                // Sold out, disable the submit button, change text, hide quantity elements
                $addToCart.addClass('disabled').prop('disabled', true);
                $addToCartText.html("Elfogyott");
                $quantityElements.hide();
            }

            // Regardless of stock, update the product price

            $productPrice.html(variant.price);
            // Also update and show the product's compare price if necessary
            if (variant.compare_at_price > variant.price) {

                $comparePrice
                    .html(variant.compare_at_price)
                    .addClass('show')
                    .removeClass('hide')
                    .fadeIn();
            } else {
                $comparePrice.removeClass('show').addClass('hide');
            }

        } else {
            // The variant doesn't exist, disable submit button.
            // This may be an error or notice that a specific variant is not available.
            // To only show available variants, implement linked product options:
            //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
            $addToCart.addClass('disabled').prop('disabled', true);
            $addToCartText.html("Nem elérhető");
            $quantityElements.hide();
        }
    };
});


$(document).ready(function () {
    timber.productSinglePage = function (options) {
        var moneyFormat = options.money_format,
            variant = options.variant,
            selector = options.selector;


        // Selectors
        var $productImage = $('#ProductPhotoImg'),
            $addToCart = $('#AddToCart'),
            $productTitle = $('#productTitle'),
            $productPrice = $(options.priceSelector),
            $comparePrice = $('.product-single #compare'),
            $quantityElements = $('.quantity-selector, label + .js-qty'),
            $addToCartText = $('#AddToCartText');

        if (variant) {

            // Update variant image, if one is set
            if (variant.featured_image) {
                var newImg = variant.featured_image,
                    el = $productImage[0];
                Shopify.Image.switchImage(newImg, el, timber.switchImage);
            }

            // Select a valid variant if available
            if (variant.available) {
                // Available, enable the submit button, change text, show quantity elements
                $addToCart.removeClass('disabled').prop('disabled', false);
                $addToCartText.html("Kosárba");
                $quantityElements.show();
            } else {
                // Sold out, disable the submit button, change text, hide quantity elements
                $addToCart.addClass('disabled').prop('disabled', true);
                $addToCartText.html("Elfogyott");
                $quantityElements.hide();
            }

            // Regardless of stock, update the product price

            // TODO: ezt kikommenteztük a törzsprogram miatt amugy arra van ha a variant más áron kaphato mint a termék más variánsai.
            //$productPrice.html(Shopify.formatMoney(variant.price * getVatCategory(options.product), moneyFormat));

            // Also update and show the product's compare price if necessary
            if (variant.compare_at_price > variant.price) {

                $comparePrice
                    .html(Shopify.formatMoney(variant.compare_at_price * getVatCategory(options.product), moneyFormat))
                    .addClass('show')
                    .removeClass('hide')
                    .fadeIn();
            } else {
                $comparePrice.removeClass('show').addClass('hide');
            }

        } else {
            // The variant doesn't exist, disable submit button.
            // This may be an error or notice that a specific variant is not available.
            // To only show available variants, implement linked product options:
            //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
            $addToCart.addClass('disabled').prop('disabled', true);
            $addToCartText.html("Nem elérhető");
            $quantityElements.hide();
        }
    };
});

function splitTitle(title) {
    var $productTitle = title;
    if ($productTitle.length && ($productTitle.text().indexOf('-') != -1)) {

        var result = $productTitle.text().split('-');

        if (result.length > 1) {
            var last = result.pop();
            var text = "";

            for (var i = 0; i < result.length; i++) {
                if (i >= 0) {
                    if (i == result.length - 1) {
                        text += result[i];
                    } else {
                        text += result[i] + " - ";
                    }

                }
            }
        }
        $productTitle.html(text + '<span>' + last + '</span>');
    }
}


$(function () {
    $(document).on('click', '.popup-addtocart', function (e) {

        var popup = $(this).parents('.remodal ');

        $(popup).remodal().close();

    });


});


$(function () {
    $('.size-select').click(function (e) {
        e.preventDefault();

        var target = $(this).attr('data-target'),
            select = $(this).attr('data-size'),
            targetElem = $('div[data-remodal-id=' + target + ']'),
            productID = $(this).attr('data-id'),

            targetSelect = targetElem.find('select[data-option="option1"]'),
            selected = $(targetSelect).find('option:selected');

        $(targetSelect).find('option').each(function (elem) {
            $(this).removeAttr("selected");

        });


        setTimeout(function () {
            $(targetSelect).find('option[value="' + select + '"]').prop("selected", true);
            $(targetSelect).trigger('change');
        }, 200);


        targetElem.remodal().open();
    });
});


$(function () {
    /*
     $('ul#nav-collection').each(function () {

     var LiN = $(this).find('li').length;

     if (LiN > 6) {
     $('li', this).eq(5).nextAll().hide().addClass('toggleable');
     $(this).append('<li class="more"><span class="text">  Bővebben</span>  <i>&#9660;</i>   </li>');
     }

     }); */


    $('ul#nav-collection').on('click', '.more', function () {

        if ($(this).hasClass('less')) {
            $(this).removeClass('less').find('.text').text("Bővebben");
            $(this).find('i').removeClass('rotated');
        } else {
            $(this).addClass('less').find('.text').text("Visszazár");
            $(this).find('i').addClass('rotated');
        }

        $(this).siblings('li.toggleable').slideToggle();


    });


});
$(function () {


    if (jQuery.isFunction(jQuery.fn.truncate)) {
        var truncate = $('.product-description').truncate({
            lines: 20
        });

    }

    function reCalc() {

        setTimeout(function () {


            topMenu = $(".info-tabs > ul"),
                topMenuHeight = topMenu.outerHeight() + 5,
                menuItems = topMenu.find("a");


            menuItems.each(function () {
                var href = $(this).attr("href");
                $(this).attr('data-top', $(href).position().top - topMenuHeight);


            });
        }, 500)
    }

    $('#leiras').on('click', '.more', reCalc);

    $('body').on('click', '#judgeme_newreview', reCalc);
    $('body').on('click', '#judgeme_show_all_link', reCalc);
    $('body').on('click', '#judgeme_show_less_link', reCalc);


})

$(function () {

    $(document).on('opened', '.remodal', function (e) {
        var selects = $(e.currentTarget).find('select');
        $(selects).each(function () {
            $(this).trigger('change');
        });

    })


});



$(function () {

    $('.review-us').click(function (e) {
        var $reviews = $("#ertekeles");
        $('html, body').animate({
            scrollTop: $reviews.offset().top - 50
        }, 1000);


    })


    $('.more-info').click(function (e) {
        let override_default_jump_to = false;
        let jump_here_container = $('.info-tabs');

        if ($('#jump-here').length) {
            jump_here_container = $('#jump-here');
        }

        $('.product-description').truncate('expand');
        $('.more').addClass('less').find('.text').text("Visszazár");
        $('.more').find('i').addClass('rotated');
        $('html, body').animate({
            scrollTop: jump_here_container.offset().top
        }, 1000);


    })
});



$(function () {
    $(document).ready(function () {
        $('#collection-description .backToTop').click(function () {
            $('body,html').stop().animate({
                scrollTop: 0
            }, 850);

        });
    });


    $(document).ready(function () {
        $('#category-header .toBottom').click(function () {

            $('body,html').stop().animate({
                scrollTop: $('#collection-description').offset().top
            }, 850);

        });
    })


});



$(function () {
    var $carousel = $('#carousel');
    if ($carousel.length) {
        $carousel.on('init', function (slick) {

            $carousel.addClass('loaded');
        })
            .slick({
                autoplaySpeed: 5000,
                autoplay: true,
                dots: true,
                adaptiveHeight: false,
                prevArrow: '<button type="button" class="icon-left-open-big">Előző</button>',
                nextArrow: '<button type="button" class="icon-right-open-big">Következő</button>'

            });
        $carousel.on('afterChange', function (event, slick, currentSlide) {
            //      var name = $(event.target).find('.slick-current img').attr('alt');
            //    analyticsEvents.sliderView(currentSlide, name);
        });


    }

});
$(function () {
    var $carousel = $('.carousel');
    var $carousel2 = $('.upsell-carousel');

    if ($carousel.length) {
        $carousel.on('init', function (slick) {

            $carousel.addClass('loaded');
        })
            .slick({
                autoplaySpeed: 5000,
                autoplay: true,
                dots: true,
                adaptiveHeight: false,
                prevArrow: '<button type="button" class="icon-left-open-big">Előző</button>',
                nextArrow: '<button type="button" class="icon-right-open-big">Következő</button>'

            });
        $carousel.on('afterChange', function (event, slick, currentSlide) {
            //   var name = $(event.target).find('.slick-current img').attr('alt');
            //  analyticsEvents.sliderView(currentSlide, name);
        });


    }


    if ($carousel2.length) {
        $carousel2.on('init', function (slick) {

            $carousel2.addClass('loaded');
        }).slick({
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 4,
            autoplaySpeed: 5000,
            autoplay: true,
            dots: true,
            adaptiveHeight: false,
            prevArrow: '<button type="button" class="icon-left-open-big">Előző</button>',
            nextArrow: '<button type="button" class="icon-right-open-big">Következő</button>',

            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        dots: false
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: false
                    }
                }
                // You can unslick at a given breakpoint now by adding:
                // settings: "unslick"
                // instead of a settings object
            ]


        });
    }
});


$(document).ready(function () {
    if ($('.tabs-horizontal').length) {

        $('.tabs-horizontal').tabslet();
    }
    if ($('.tabs-vertical').length) {

        $('.tabs-vertical').tabslet();
    }

});



$(function () {

    $('.product,#also-bought,.search-res-full').on('click', '.buy-btn', function (e) {
        e.preventDefault();

        var desc = $(this).attr('data-desc') ? $(this).attr('data-desc') : false;
        var vat = 1;


        //  var vat = $(this).attr('data-vat');
        var shop_url = "";

        var sale = $(this).attr('data-sale') == "true" || $(this).attr('data-sale') == "1";
        var id = $(this).attr('data-id');
        var search_url = "/search?type=product&q=id:" + id + "&view=family";
        var handle = $(this).attr('data-handle') ? $(this).attr('data-handle') : false;
        var unitPrice = $(this).attr('data-unitPrice');
        var new_product = $(this).attr('data-new') == "true";
        var url = $(this).attr('data-url');
        if (handle === false) {

            $.getJSON(search_url)
                .then(function (data) {
                    handle = data.handle;
                    desc = data.desc;
                    family = data.family;
                    if (family) {
                        family = family.split(',').map(function (e) {

                            return e.split('|');

                        }).slice(0, -1);
                        family = family.sort(function (a, b) {
                            a = parseInt(a[0].replace(/\s+/g, ''));
                            b = parseInt(b[0].replace(/\s+/g, ''));

                            if (a == b) {
                                return 0;
                            }
                            if (a > b) {
                                return 1;
                            }
                            else {
                                return -1;
                            }
                        });

                    }


                    var modal = $('#productModal');
                    Shopify.getProduct(handle, function (p) {
                        var source = $("#template").html();
                        var template = Handlebars.compile(source);
                        var selectCallback = function (variant, selector) {

                            timber.productCatalogPage({
                                money_format: "",
                                variant: variant,
                                selector: selector,
                                product: p,
                                priceSelector: "#ProductPrice-" + p.id,
                                priceBeforeSelector: "#ProductPriceBefore-" + p.id
                            });

                        };
                        $.map(p.variants, function (val, i) {
                            if (val.compare_at_price < val.price) {
                                val.price = Shopify.formatMoney(Math.floor(val.price * vat * multiplier));
                                val.compare_at_price = Shopify.formatMoney(Math.floor(val.compare_at_price * vat * multiplier));
                            } else {
                                val.price = Shopify.formatMoney(val.price);
                                val.compare_at_price = Shopify.formatMoney(val.compare_at_price);
                            }
                        });
                        if (p.compare_at_price < p.price) {
                            //  console.log(p.price * vat * multiplier)
                            p.price = Shopify.formatMoney(p.price * multiplier);
                            p.price_max = Shopify.formatMoney(Math.floor(p.price_max  * multiplier));
                            p.price_min = Shopify.formatMoney(Math.floor(p.price_min * multiplier));
                            p.compare_at_price = Shopify.formatMoney(Math.floor(p.compare_at_price * multiplier));
                        }
                        else {
                            p.price = Shopify.formatMoney(p.price);
                            p.price_max = Shopify.formatMoney(p.price_max);
                            p.price_min = Shopify.formatMoney(p.price_min);
                            p.compare_at_price = Shopify.formatMoney(p.compare_at_price);
                        }

                        if (!family) {
                            var url_family = "/search?type=product&q=id:" + data.shopify_id + "&view=family";
                            //  console.log(data, url);
                            // $.getJSON(url_family, function (res) {

                            //     console.log(res);
                            //  });

                            var html = template({
                                product: p,
                                desc: desc,
                                sale: sale,
                                unitPrice: unitPrice,
                                new_product: new_product,
                                url: url,
                                family: family,
                                variant_name: p.options[0].name
                            });

                            modal.html(html);
                        } else {
                            var html = template({
                                product: p,
                                desc: desc,
                                sale: sale,
                                unitPrice: unitPrice,
                                new_product: new_product,
                                url: url,
                                family: family,
                                variant_name: p.options[0].name
                            });
                            modal.html(html);
                        }


                        // SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges();

                        var option = new Shopify.OptionSelectors('productSelect-' + p.id, {
                            product: p,
                            onVariantSelected: selectCallback,
                            enableHistoryState: false
                        });

                        // Add label if only one product option and it isn't 'Title'. Could be 'Size'.
                        if (p.options.size == 1 && p.options[0] != 'Title') {
                            var wrapper = modal.find('.selector-wrapper');

                            $(wrapper).append('<label for="productSelect-option-0" class="float-label">' + p.options[0] + '</label>');

                        }

                        // Hide selectors if we only have 1 variant and its title contains 'Default'.

                        if (p.variants.length == 1 && p.variants[0].title.toLowerCase().indexOf("default") >= 0) {


                            modal.find('.selector-wrapper').hide();

                        }


                        var inst = $('#productModal').remodal();
                        $('#productModal').on('click', '.popup-addtocart', function (e) {


                            inst.close();

                        });
                        inst.open();
                        ajaxCart.init({
                            formSelector: '#productModal .AddToCartForm',
                            cartContainer: '#CartContainer',
                            addToCartSelector: '#AddToCart',
                            cartCountSelector: null,
                            cartCostSelector: '#CartCost',
                            moneyFormat: null
                        });
                    });

                })

        }
        else {


            var family = $(this).attr('data-family');


            if (family.length > 0) {
                family = family.split(',').map(function (e) {
                    return e.split('|');
                }).slice(0, -1);


                family = family.sort(function (a, b) {

                    a = parseInt(a[0].replace(/\s+/g, ''));
                    b = parseInt(b[0].replace(/\s+/g, ''));


                    if (a == b) {
                        return 0;
                    }
                    if (a > b) {
                        // if a should come after b, return 1
                        return 1;
                    }
                    else {
                        // if b should come after a, return -1
                        return -1;
                    }
                });


            }


            var url = $(this).attr('data-url');
            var modal = $('#productModal');
            Shopify.getProduct(handle, function (p) {
                var source = $("#template").html();
                var template = Handlebars.compile(source);
                var selectCallback = function (variant, selector) {

                    timber.productCatalogPage({
                        money_format: "",
                        variant: variant,
                        selector: selector,
                        product: p,
                        priceSelector: "#ProductPrice-" + p.id,
                        priceBeforeSelector: "#ProductPriceBefore-" + p.id
                    });

                };

                $.map(p.variants, function (val, i) {
                    if (val.compare_at_price_ < val.price) {
                        val.price = Shopify.formatMoney(Math.floor(val.price * vat * multiplier));
                        val.compare_at_price = Shopify.formatMoney(Math.floor(val.compare_at_price * vat * multiplier));
                    } else {
                        val.price = Shopify.formatMoney(val.price);
                        val.compare_at_price = Shopify.formatMoney(val.compare_at_price);
                    }
                });
                if (p.compare_at_price < p.price) {
                    //  console.log(p.price * vat * multiplier)
                    p.price = Shopify.formatMoney(Math.floor(p.price * vat * multiplier));
                    p.price_max = Shopify.formatMoney(Math.floor(p.price_max * vat * multiplier));
                    p.price_min = Shopify.formatMoney(Math.floor(p.price_min * vat * multiplier));
                    p.compare_at_price = Shopify.formatMoney(Math.floor(p.compare_at_price * multiplier));
                }
                else {
                    p.price = Shopify.formatMoney(p.price);
                    p.price_max = Shopify.formatMoney(p.price_max);
                    p.price_min = Shopify.formatMoney(p.price_min);
                    p.compare_at_price = Shopify.formatMoney(p.compare_at_price);
                }
                console.log(p.options);
                var html = template({
                    product: p,
                    desc: desc,
                    sale: sale,
                    unitPrice: unitPrice,
                    new_product: new_product,
                    url: url,
                    family: family,
                    variant_name: p.options[0].name
                });

                modal.html(html);

                var option = new Shopify.OptionSelectors('productSelect-' + p.id, {
                    product: p,
                    onVariantSelected: selectCallback,
                    enableHistoryState: false
                });

                // Add label if only one product option and it isn't 'Title'. Could be 'Size'.
                if (p.options.size == 1 && p.options[0] != 'Title') {
                    var wrapper = modal.find('.selector-wrapper');

                    $(wrapper).append('<label for="productSelect-option-0" class="float-label">' + p.options[0] + '</label>');

                }

                // Hide selectors if we only have 1 variant and its title contains 'Default'.

                if (p.variants.length == 1 && p.variants[0].title.toLowerCase().indexOf("default") >= 0) {


                    modal.find('.selector-wrapper').hide();

                }


                var inst = $('#productModal').remodal();
                $('#productModal').on('click', '.popup-addtocart', function (e) {


                    inst.close();

                });
                inst.open();
                ajaxCart.init({
                    formSelector: '#productModal .AddToCartForm',
                    cartContainer: '#CartContainer',
                    addToCartSelector: '#AddToCart',
                    cartCountSelector: null,
                    cartCostSelector: '#CartCost',
                    moneyFormat: null
                });
            });
        }


    });
});

$(function () {

});

$(function () {
    $('.tabs ul li a').click(function () {
        var target = $(this).attr('href');

        //  setTimeout(function () {
        //     $(target).slick('setPosition');
        //     $.fn.matchHeight._update();
        //  }, 200)


    })
});

$(function () {


});

var search = function (options) {

    var self = this,
        opt = options,
        isSearch = false,

        init = function () {

            return container = options.container,
                templateHTML = options.template ? options.template : $("#template-search-results").html(),
                input = options.input,
                afterQuery = options.afterQuery,
                closeOnOutsideClick = options.closeOnOutsideClick ? options.closeOnOutsideClick : false,
                queryOnLoad = options.queryOnLoad ? options.queryOnLoad : false

        },
        afterQuery = function () {
            //         console.log('after')
        },

        container = $('.search-res'),
        queryOnLoad = false,
        input = $('input#header-search'),

        performQuery = function (val, url, template) {
            var query = $.post(url,
                {
                    q: val,
                    s: 'start',
                    productSearchCh: 1,
                    videoSearchCh: 1,
                    newsSearchCh: 1,
                    edzesSearchCh: 0,
                    etrendSearchCh: 0
                }, "json");

            query.done(function (data) {
                if (data.items.product) {
                    $.map(data.items.product, function (item, i) {

                        $.getJSON('/search?type=product&q=id:' + item.shopify_id + '&view=family').then(function (res) {
                            if (res) {
                                if (res.available) item.available = res.available;
                                if (res.reviews) item.product_reviews = res.reviews;
                                if (res.unitPrice) item.unit_price = res.unitPrice;
                                if (res) {
                                    item.visible = 1;
                                }
                            }
                        }).then(function () {
                            var saleString = "Akció";

                            var newString = "Új";

                            var html = template({
                                    items: data.items,
                                    count: data.count,
                                    on_sale_string: saleString,
                                    new_string: newString
                                }, {
                                    data: {
                                        intl: {
                                            "locales": "hu-HU"
                                        }
                                    }
                                }
                            );

                            addHtml(html);

                            afterQuery();
                        })

                    });
                } else {

                    var saleString = "Akció";

                    var newString = "Új";

                    var html = template({
                            items: data.items,
                            count: data.count,
                            on_sale_string: saleString,
                            new_string: newString
                        }, {
                            data: {
                                intl: {
                                    "locales": "hu-HU"
                                }
                            }
                        }
                    );

                    addHtml(html);

                    afterQuery();
                }


            }, "json");
        },
        addHtml = function (html) {
            if (isSearch) {
                container.find('.loading').fadeOut();
                container.empty().append(html);
            } else {
                container.empty().append(html);
            }

        },
        close = function () {
            container.removeClass('show');
        },
        open = function () {

            container.addClass('show');
        },
        load = function () {
            isSearch = true;
            container.empty().append('<div class="topics"><p class="h3 loader"></p></div>');
        },
        timer;

    init();
    //   console.log(container);

    $('.clear-search').click(function (e) {
        e.preventDefault();
        input.val('');
        $(this).removeClass('visible');
    });
    if (queryOnLoad) {
        var template = Handlebars.compile(templateHTML);
        var url = "//biotechusa.hu/index.php?name=cms&func=include&file=productSearchShopify";
        var val = input.val();
        if (val != "") {
            load();
            open();


            $('.clear-search').removeClass('visible');


            if (input.val() != '' && input.val().length > 2) {

                performQuery(val, url, template);
            } else {
                addHtml('<div class="topics"><h3 class="text-center  search-not-found">Adj meg legalább 3 karaktert a kereséshez</h3></div>')
            }

        }
    }


    input.on('keyup', function (e) {
        var template = Handlebars.compile(templateHTML);
        clearTimeout(timer);
        var ms = 400;
        var url = "//biotechusa.hu/index.php?name=cms&func=include&file=productSearchShopify";
        var val = $(this).val();
        timer = setTimeout(function () {

            load();
            open();

            if (input.val().length > 0) {
                $('.clear-search').addClass('visible');
            } else {
                $('.clear-search').removeClass('visible');
            }

            if (input.val() != '' && input.val().length > 2) {

                performQuery(val, url, template);
            } else {
                addHtml('<div class="topics"><h3 class="text-center h3 search-not-found">Adj meg legalább 3 karaktert a kereséshez</h3></div>')
            }
        }, ms);


    });
    if (closeOnOutsideClick) {
        $('body').on('click', function (e) {
            var target = $(e.target);
            if (target.closest('.search-res').length === 0) {
                close();
            }
        });

        container.on('click', ':not(a)', function (e) {
            var href = $(e.target).attr('href');
            var name = $(e.target).attr('name');

            if ($(e.target).hasClass('remodal-close')) {
                close();
            }

            if (typeof href === typeof undefined && href === false || typeof name === typeof undefined && name === false) {
                return false
            }
        });
    }
    return container;
};
var searchFull = function (options) {
    var self = this,
        opt = options,
        isSearch = false,

        init = function () {

            return container = $('.search-res-full'),
                templateHTML = $("#template-search-results-full").html(),
                input = $('input#search-full'),
                afterQuery = options.afterQuery,
                closeOnOutsideClick = options.closeOnOutsideClick ? options.closeOnOutsideClick : false,
                queryOnLoad = options.queryOnLoad ? options.queryOnLoad : false

        },
        afterQuery = function () {
            //    console.log('after')
        },
        container = $('.search-res-full'),
        templateHTML = $("#template-search-results-full").html(),
        input = $('input#search-full'),
        afterQuery = options.afterQuery,
        closeOnOutsideClick = options.closeOnOutsideClick ? options.closeOnOutsideClick : false,
        queryOnLoad = options.queryOnLoad ? options.queryOnLoad : false,
        container = options.container,
        queryOnLoad = options.queryOnLoad,
        input = options.input,

        performQuery = function (val, url, template) {
            var query = $.post(url,
                {
                    q: val,
                    s: 'start',
                    productSearchCh: 1,
                    videoSearchCh: 1,
                    newsSearchCh: 1,
                    edzesSearchCh: 0,
                    etrendSearchCh: 0
                }, "json");

            query.done(function (data) {

                if (data.items.product) {
                    $.map(data.items.product, function (item, i) {

                        $.getJSON('/search?type=product&q=id:' + item.shopify_id + '&view=family').then(function (res) {

                            item.available = res.available;
                            item.product_reviews = res.reviews;
                            item.unit_price = res.unitPrice;
                            item.visible = 0;
                            if (res) {
                                item.visible = 1;
                            }

                        }).then(function () {
                            var saleString = "Akció";

                            var newString = "Új";

                            var html = template({
                                    items: data.items,
                                    count: data.count,
                                    on_sale_string: saleString,
                                    new_string: newString
                                }, {
                                    data: {
                                        intl: {
                                            "locales": "hu-HU"
                                        }
                                    }
                                }
                            );

                            addHtml(html);

                            afterQuery();
                        })

                    });
                } else {

                    var saleString = "Akció";

                    var newString = "Új";

                    var html = template({
                            items: data.items,
                            count: data.count,
                            on_sale_string: saleString,
                            new_string: newString
                        }, {
                            data: {
                                intl: {
                                    "locales": "hu-HU"
                                }
                            }
                        }
                    );

                    addHtml(html);

                    afterQuery();
                }


            }, "json");
        },
        addHtml = function (html) {
            if (isSearch) {
                container.find('.loading').fadeOut();
                container.empty().append(html);
            } else {
                container.empty().append(html);
            }

        },
        close = function () {
            container.removeClass('show');
        },
        open = function () {

            container.addClass('show');
        },
        load = function () {
            isSearch = true;
            container.empty().append('<div class="topics"><p class="h3 loader"></p></div>');
        },
        timer;

    init();

    $('.clear-search').click(function (e) {
        e.preventDefault();
        input.val('');
        input.trigger('keyup');
        $(this).removeClass('visible');
    });
    if (queryOnLoad) {
        var template = Handlebars.compile(templateHTML);
        var url = "//biotechusa.hu/index.php?name=cms&func=include&file=productSearchShopify";
        var val = input.val();
        if (val != "") {
            load();
            open();


            $('.clear-search').removeClass('visible');


            if (input.val() != '' && input.val().length > 2) {
                $('.clear-search').addClass('visible');
                performQuery(val, url, template);
            } else {
                $('.clear-search').removeClass('visible');
                addHtml('<div class="topics"><h3 class="text-center  search-not-found">Adj meg legalább 3 karaktert a kereséshez</h3></div>')
            }

        }
    }


    input.on('keyup', function (e) {
        var template = Handlebars.compile(templateHTML);
        clearTimeout(timer);
        var ms = 400;
        var url = "//biotechusa.hu/index.php?name=cms&func=include&file=productSearchShopify";
        var val = $(this).val();
        timer = setTimeout(function () {

            load();
            open();

            if (input.val().length > 0) {
                $('.clear-search').addClass('visible');
            } else {
                $('.clear-search').removeClass('visible');
            }

            if (input.val() != '' && input.val().length > 2) {

                performQuery(val, url, template);
            } else {
                addHtml('<div class="topics"><h3 class="text-center h3 search-not-found">Adj meg legalább 3 karaktert a kereséshez</h3></div>')
            }
        }, ms);


    });
    if (closeOnOutsideClick) {
        $('body').on('click', function (e) {
            var target = $(e.target);
            if (target.closest('.search-res').length === 0) {
                close();
            }
        });

        container.on('click', ':not(a)', function (e) {
            var href = $(e.target).attr('href');
            var name = $(e.target).attr('name');

            if ($(e.target).hasClass('remodal-close')) {
                close();
            }

            if (typeof href === typeof undefined && href === false || typeof name === typeof undefined && name === false) {
                return false
            }
        });
    }
    return container;
};

$(document).ready(function () {
    HandlebarsIntl.registerWith(Handlebars);
    Handlebars.registerHelper('toInt', function (number) {

        return parseInt(number, 10);

    });

    Handlebars.registerHelper('chain', function () {
        var helpers = [];
        var args = Array.prototype.slice.call(arguments);
        var argsLength = args.length;
        var index;
        var arg;

        for (index = 0, arg = args[index];
             index < argsLength;
             arg = args[++index]) {
            if (Handlebars.helpers[arg]) {
                helpers.push(Handlebars.helpers[arg]);
            } else {
                args = args.slice(index);
                break;
            }
        }

        while (helpers.length) {
            args = [helpers.pop().apply(Handlebars.helpers, args)];
        }

        return args.shift();
    });

    Handlebars.registerHelper('ifCond', function (v1, operator, v2, options) {

        switch (operator) {
            case '==':
                return (v1 == v2) ? options.fn(this) : options.inverse(this);
            case '===':
                return (v1 === v2) ? options.fn(this) : options.inverse(this);
            case '!=':
                return (v1 != v2) ? options.fn(this) : options.inverse(this);
            case '!==':
                return (v1 !== v2) ? options.fn(this) : options.inverse(this);
            case '<':
                return (v1 < v2) ? options.fn(this) : options.inverse(this);
            case '<=':
                return (v1 <= v2) ? options.fn(this) : options.inverse(this);
            case '>':
                return (v1 > v2) ? options.fn(this) : options.inverse(this);
            case '>=':
                return (v1 >= v2) ? options.fn(this) : options.inverse(this);
            case '&&':
                return (v1 && v2) ? options.fn(this) : options.inverse(this);
            case '||':
                return (v1 || v2) ? options.fn(this) : options.inverse(this);
            default:
                return options.inverse(this);
        }
    });


    search({
        container: $('.search-res'),
        input: $('input#header-search'),
        closeOnOutsideClick: true,
        template: $("#template-search-results").html(),
        afterQuery: function () {
            $el = $('.search-more');
            val = $('input#header-search').val().replace(/ /g, '+');
            $el.attr("href", $el.attr("href") + val);


            $(function () {

                var lastId,
                    topMenu = $("#search-nav"),
                    topMenuHeight = topMenu.outerHeight() + 1,

                    menuItems = topMenu.find("a"),


                    scrollItems = menuItems.map(function () {
                        var item = $($(this).attr("href"));
                        if (item.length) {

                            return item;
                        }
                    });

                menuItems.each(function () {
                    var href = $(this).attr("href");
                    $(this).attr('data-top', $(href).position().top);


                });


                menuItems.on('click tap', function (e) {
                    e.preventDefault();
                    var href = $(this).attr("href");

                    offsetTop = href === "#" ? 0 : $(href).position().top;

                    $('.search-res .inner').stop().animate({
                        scrollTop: $(this).attr('data-top')
                    }, 850);
                });


                $('.search-res .inner').scroll(function () {
                    // Get container scroll position
                    var fromTop = $(this).scrollTop();
                    var halfInnerH = parseInt($(this).outerHeight() + 1) / 3;

                    // Get id of current scroll item
                    var cur = scrollItems.map(function () {
                        var href = $('[href=\\#' + $(this).attr('id') + ']');
                        var compare = href.attr('data-top') - halfInnerH;


                        if (compare < fromTop)
                            return this;
                    });
                    // Get the id of the current element
                    cur = cur[cur.length - 1];
                    var id = cur && cur.length ? cur[0].id : "";

                    if (lastId !== id) {
                        lastId = id;
                        // Set/remove active class
                        menuItems
                            .parent().removeClass("active")
                            .end().filter('[href=\\#' + id + ']').parent().addClass("active");
                    }
                });


            })
            //   $('.search-res').find('.topics').tabslet({
            //        animation: true
            //   });


        }
    });

    //search highlight + scroll


});

$(function () {
    if ($('#search-full').length) {

        var sf = searchFull({
            container: $('.search-res-full'),
            input: $('input#search-full'),
            template: $("#template-search-results-full").html(),
            queryOnLoad: true,
            afterQuery: function () {
                judgeme.badge();
                judgeme.customizeBadges();
                $('.search-res-full').find('.topics').tabslet({
                    animation: true
                });

                //$('[data-mh="eq-height"]').matchHeight();

            }
        });

    }
});



/*
 var search = {
 isSearch: false,
 container: function () {
 return $('.search-res')
 },
 input: function () {
 return $('#header-search');
 },
 template: function () {
 return $("#template-search-results").html()
 },
 addHtml: function (html) {
 if (this.isSearch) {
 this.container().find('.loading').fadeOut();
 this.container().empty().append(html);
 } else {
 this.container().empty().append(html);
 }

 },
 close: function () {
 this.container().removeClass('show');
 },
 open: function () {

 this.container().addClass('show');
 },
 load: function () {
 this.isSearch = true;
 this.container().empty().append('<div class="topics"><p class="h3 loader"></p></div>');
 }

 };*/
/* $(function () {

 var timer;

 var template = Handlebars.compile(search.template());
 $('input#header-search').on('keyup', function (e) {
 alert('a');
 clearTimeout(timer);
 var ms = 400;
 var s = "//www.biotechusashop.hu/index.php?name=cms&func=include&file=productSearchShopify";
 var val = $(this).val();
 timer = setTimeout(function () {
 search.load();
 search.open();

 var query = $.post(s,
 {
 q: val,
 s: 'start',
 productSearchCh: 1,
 videoSearchCh: 1,
 newsSearchCh: 1,
 edzesSearchCh: 1,
 etrendSearchCh: 1
 }, "json");

 query.done(function (data) {


 var html = template({items: data.items, count: data.count});

 search.addHtml(html);

 search.container().find('.topics').tabslet({
 animation: true
 });


 }, "json");

 }, ms);


 });

 $('body').on('click', function (e) {

 search.close();
 });

 $('.search-res').on('click', ':not(a)', function (e) {

 if (!($(e.target).attr('href')) || !($(e.target).attr('name'))) {
 return false
 }
 });

 }); */



function initimg() {
    var imgDefer = document.getElementsByTagName('img');
    for (var i = 0; i < imgDefer.length; i++) {
        if (imgDefer[i].getAttribute('data-src')) {
            imgDefer[i].style.opacity = 0;

            setTimeout(function (e) {
                return function () {
                    e.setAttribute('src', e.getAttribute('data-src'));
                    e.style.opacity = 1;
                }
            }(imgDefer[i]), 1000);


        }
    }
}



window.onload = initimg;








$(function () {


//    var btn = $('.buy-btn');
    //  var h = btn.outerHeight();
    //   btn.css('height', h).addClass('min');


});

$(function () {


    enquire.register("screen and (min-width:769px)", {

        // OPTIONAL
        // If supplied, triggered when a media query matches.
        match: function () {
            if (timber.LeftDrawer)
                timber.LeftDrawer.close();
        }

    });
    enquire.register("screen and (max-width:769px)", {

        // OPTIONAL
        // If supplied, triggered when a media query matches.
        match: function () {
            if (timber.LeftDrawer)
                timber.LeftDrawer.close();
        }

    });

});

$(function () {


});





$(function () {
    $('.drawer').on('click', '.close-cart', function () {
        timber.RightDrawer.close();
    })
})
/*
$(function () {
    $('.cart-mh').matchHeight({
        byRow: true,
        property: 'min-height',

    });


});*/

$(function () {
    var button = $('.search-button');
    var i = $('.search-button .icon');
    var input = $('.site-header__search');
    var close = $('.close-search');
    close.click(function (e) {
        e.preventDefault();
        input.removeClass('open');
    });

    button.click(function (e) {
        e.preventDefault();
        input.toggleClass('open');

    })
})


$(function () {

    Shopify.onCartUpdate = function (cart) {
        //    console.log(cart);
    };

});

$(function () {
    var lastId,
        topMenu = $(".info-tabs > ul"),
        topMenuHeight = topMenu.outerHeight() + 5,
        menuItems = topMenu.find("a"),
        scrollItems = menuItems.map(function () {
            var item = $($(this).attr("href"));
            if (item.length) return item;
        });

    var touchStartX = 0;
    var touchStartY = 0;
    var isSwiping = false;

    topMenu.on("touchstart", function (e) {
        touchStartX = e.originalEvent.touches[0].clientX;
        touchStartY = e.originalEvent.touches[0].clientY;
        isSwiping = false;
    });

    topMenu.on("touchmove", function (e) {
        var touchMoveX = e.originalEvent.touches[0].clientX;
        var touchMoveY = e.originalEvent.touches[0].clientY;

        // Ha a vízszintes mozgás nagyobb, mint a függőleges, akkor swipe-olunk
        if (Math.abs(touchMoveX - touchStartX) > 30 && Math.abs(touchMoveY - touchStartY) < 20) {
            isSwiping = true;
        }
    });

    menuItems.on("click", function (e) {
        if (isSwiping) return; // Ha swipe-olt a user, nem fut le a click
        e.preventDefault();
        var $this = $(this);
        var href = $(this).attr("href");
        var offsetTop = href === "#" ? 0 : $(href).offset().top;

        $("html, body").stop().animate({ scrollTop: offsetTop }, 850);

        setTimeout(function () {
            $this.parents("li").siblings("li").removeClass("active");
            $this.parents("li").addClass("active");
        }, 650);
    });

    $(document).scroll(function () {
        var fromTop = $(this).scrollTop();
        var cur = scrollItems.map(function () {
            var href = $('[href=\\#' + $(this).attr("id") + "]");
            var compare = href.attr("data-top") - 5;
            if (compare < fromTop) return this;
        });

        cur = cur[cur.length - 1];
        var id = cur && cur.length ? cur[0].id : "";

        if (lastId !== id) {
            lastId = id;
            menuItems.parent().removeClass("active");
            menuItems.filter('[href=\\#' + id + ']').parent().addClass("active");
        }
    });
});

$(function () {


    /*setTimeout(function () {

        TODO: del!!!

        var cf_sidebar = $('#collection-filters-container').clone();
        var sidebar = $('#collection-filters-container-sidebar');

        var cb = $('input.cf-checkbox[type=checkbox]:checked');
        var button = $('#filter-button');
        var $count = $('.filter-count');
        var close = $('.filter-close');
        var filters = $('#collection-filters-container').clone();

        sidebar.closest('.sidebar').html(cf_sidebar);
        $('.sidebar').prepend('<span class="filters--title">Szűrés</span>');
        $('.sidebar').find('button.letsfilter').hide();
        $('.sidebar').find('.confirm-filter').hide();

        filters.appendTo('body').addClass('mobile-filters').prepend('<span class="remodal-close filter-close small--show medium--show large--hide"></span>');
        filters.on("click", ".letsfilter", CollectionFilterChange);
        cf_sidebar.on("click", "input:checkbox", CollectionFilterChange);
        cf_sidebar.on('click', '.delete-filter', function() {
            CollectionFilterChange('');
        })

        var checkboxes = $('.sidebar').find('.cf-checkbox')
        var selected_value = '';
        $.each(checkboxes, function() {
            if ($(this).is(':checked') && $(this).val()) {
                selected_value = $(this).next('span').html();
                $('.selected-facets').append(`<div class="selected-facets--item">${selected_value}</div>`);
            }
        });

        button.click(function (e) {
            e.preventDefault();
            filters.addClass('active');
        });
        filters.on('click', '.filter-close', function (e) {
            e.preventDefault();
            filters.removeClass('active');
        });


        $count.html(cb.length);
    }, 3000);*/


});


// Activation flow
$(function () {

    function show() {
        let display_functions = {
            animate: 'slideDown',
            static: 'show'
        };

        if (typeof activation_slide_effect !== 'undefined' && activation_slide_effect == false) {
            return display_functions.static
        }

        return display_functions.animate;
    }

    function hide() {
        let display_functions = {
            animate: 'slideUp',
            static: 'hide'
        };

        if (typeof activation_slide_effect !== 'undefined' && activation_slide_effect == false) {
            return display_functions.static
        }

        return display_functions.animate;
    }

    function validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    var loader = "<div class='loader-spin'></div>";

    var $inviteButton = $('#invite-button');
    var $passInput = $('#CustomerPassword');
    var $passLabel = $('label[for="CustomerPassword"]');
    var $loginButton = $('#loginButton');
    var $forgot = $('.forgot-pw, .oxi-social-login, .or');
    var isLoading = false;

    var $activationInfo = $('#activationInfo');
    var $registerAlert = $('#registerAlert');
    var $activationSuccess = $('.activationSuccess');
    $passInput.attr('disabled', 'disabled');
    $registerAlert.slideUp();

    $('.activation-re').click(function (e) {
        e.preventDefault();
        $activationInfo[show()]();
        $activationSuccess[hide()]();
        $('#CustomerEmail,#invite-button').addClass('show').removeClass('hide');
    });


    function invitationCheck(input) {

        var mail = encodeURIComponent(input.val().toLowerCase()),
            shop = Shopify.shop;

        var url = "https://emarsys.biotechusa.com/userEmailExistValid?email=" + mail +"&shop="+shop;

        $.getJSON(url).then(function (data) {
            $('.loader-spin').remove();
            isLoading = false;

            if (data.found != false) {

                //var fname = data.first_name;
                //var lname = data.last_name;
                var state = data.state;

                var id = data.id;
                $registerAlert.slideUp();
                if (state == 'disabled') {
                    var $loadingAnim = $('.loading-anim');

                    $passInput.addClass('hide').removeClass('show').attr('disabled', 'disabled');
                    $passLabel.addClass('hide').removeClass('show');
                    $loginButton.addClass('hide').removeClass('show');
                    $forgot.addClass('hide').removeClass('show');
                    $inviteButton.removeClass('hide').addClass('show').attr('data-id', id);
                    $activationInfo[show()]();
                    $activationSuccess[hide()]();

                    var url = "https://emarsys.biotechusa.com/userGenerateActivationLink?id=" + id+"&shop="+shop;
                    $.getJSON(url).then(function (activation_url_respone) {
                        if (activation_url_respone.success == true) {
                            var activation_url = activation_url_respone.account_activation_url;
                            // TODO: Itt is settingből jöjjön
                            var url = 'https://emarsys.biotechusa.com/sendactivation?shop='+shop+'&email=' + mail + '&activation_url=' + activation_url;

                            $inviteButton.click(function (e) {
                                e.preventDefault();
                                $loadingAnim.css('bottom', '1px');
                                $loadingAnim.removeClass('hidden');
                                $.getJSON(url).then(function (datab) {
                                    if (datab.status == true) {
                                        $loadingAnim.addClass('hidden');
                                        $activationInfo[hide()]();
                                        $activationSuccess.find('.email').html(decodeURIComponent(mail));
                                        $activationSuccess[show()]();
                                        analyticsEvents.sendActivation();
                                        $('html, body').animate({
                                            scrollTop: 0
                                        }, 500);
                                        $('#CustomerEmail,#invite-button').addClass('hide').removeClass('show');
                                    }
                                });
                            });
                        }


                    });

                }
                else if (state == 'invited') {
                    $passInput.addClass('hide').removeClass('show').attr('disabled', 'disabled');
                    $passLabel.addClass('hide').removeClass('show');
                    $loginButton.addClass('hide').removeClass('show');
                    $forgot.addClass('hide').removeClass('show');
                    $inviteButton.removeClass('hide').addClass('show').attr('data-id', id);
                    $activationInfo.slideUp();
                }
                else if (state == 'enabled') {
                    $inviteButton.removeClass('show').addClass('hide');
                    $passInput.addClass('show').removeClass('hide').removeAttr('disabled');
                    $passLabel.addClass('show').removeClass('hide');
                    $loginButton.addClass('show').removeClass('hide');
                    $forgot.addClass('show').removeClass('hide');
                    $activationInfo.slideUp();

                }
                else {
                    $inviteButton.removeClass('show').addClass('hide');
                    $passInput.addClass('show').removeClass('hide').attr('disabled', 'disabled');
                    $passLabel.addClass('show').removeClass('hide');
                    $loginButton.addClass('show').removeClass('hide');
                    $forgot.addClass('show').removeClass('hide');
                    $activationInfo.slideUp();


                }
            } else {

                $inviteButton.removeClass('show').addClass('hide');
                $passInput.addClass('show').removeClass('hide').attr('disabled', 'disabled');
                $passLabel.addClass('show').removeClass('hide');
                $loginButton.addClass('show').removeClass('hide');
                $forgot.addClass('show').removeClass('hide');
                $activationInfo.slideUp();


                if (validateEmail(decodeURIComponent(mail))) {

                    $registerAlert.slideDown().css('display', 'flex');
                }
            }

        });
    }

    function invitationCheckFake() {
        $('.loader-spin').remove();
        isLoading = false;
        $inviteButton.removeClass('show').addClass('hide');
        $passInput.addClass('show').removeClass('hide').removeAttr('disabled');
        $passLabel.addClass('show').removeClass('hide');
        $loginButton.addClass('show').removeClass('hide');
    }

    var $email = $('#CustomerEmail');
    if ($email.length) {
        if ($email.val().length) {
            if (biotech_day_is_active) {
                invitationCheckFake();
            } else {
                invitationCheck($email);
            }
        }
    }

    $email.on('input', function () {
        delay(function () {
            if (!isLoading) {
                $email.after(loader);
                isLoading = true;
            }
            if (biotech_day_is_active) {
                invitationCheckFake();
            } else {
                invitationCheck($email);
            }
        }, 500);
    });


});


//account


$(function () {

    if (getParameterByName('activated') == '1') {
        //TODO: ezt szebben `` közé és akkor nincs gond az '-al meg hát az url változó is kéne bele..
        var activation_text = '<p>Üdvözlünk, <b>##name##</b></p><p>sikeresen aktiváltad a fiókodat!</p>';
        activation_text = activation_text.replace("##name##", loggedincustomer.name);

        var modal = $('<div id="activatedModal"> <button data-remodal-action="close" class="remodal-close"></button><i class="icon-check-1"></i>'+activation_text+'</div>').appendTo('body');

        var inst = modal.remodal();

        inst.open();

        $.getJSON(url).then(function (data) {
            //TODO: GDPR?
            analyticsEvents.accountActivated();
        });


    }
    if (getParameterByName('couponNotExists') == '1') {

        $('.discount-alert').removeClass('hide');

    }

});



// IFS Fields to customer meta

$(function () {


    $(document).ready(function () {


        function saveCustomerCustomMeta(elem) {
            var $elem = $(elem),
                fieldName = $(elem).attr('data-name'),
                nameSpace = $(elem).attr('data-namespace'),
                val = $(elem).val(),
                url = "https://biotechusa.hu/test/shopify/userAddMeta.php";


            $.post(url, {
                field: fieldName,
                namespace: nameSpace,
                value: val,
                id: loggedincustomer.id,
                hash: loggedincustomer.hash
            })
                .then(function (data) {
                    if (data.success == "true") {
                        //    console.log(data);
                    } else {

                    }
                });


        }

        //   $('.customer-meta-info').on('keyup', function () {
        //      saveCustomerCustomMeta(this);
        //    })


        initVivnetworks();
    });

});

/*$(window).on('orientationchange', function () {

    $.fn.matchHeight._update();
});*/

$(function () {
    $('.fb-help-btn').click(function () {
        //$('.fb-help').slideToggle();
        zE.activate();
    })
})




//Top Search Terms
$(function () {
    var searchContainer = $("#search-terms .searches");
    var url = "https://biotechusa.hu/test/shopify/algoliaTopSearch.php";


    if (searchContainer.length) {
        searchContainer.html('');
        $.getJSON(url, function (res) {

            var d = res.searches;
            if(!d) $("#search-terms").hide();
            $.each(d.slice(0, 15), function (i, data) {
                if (!data.search == "") {
                    var ul_data = "<li><a href='/search?q=" + data.search + "'>" + data.search + "</a></li>";
                    searchContainer.append(ul_data);
                }
            });
        })
    }


})


$(function () {
    <!-- CUSTOM DISCOUNT APPLICATOR -->


    // Gets a parameter identified by name from the url query string
    function getParameterByName(name) {
        var url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);

        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    var discount = getParameterByName('discount');
    if (discount && discount != "") {
        var xmlHttp = new XMLHttpRequest();
        xmlHttp.open("GET", "https://" + window.location.hostname + "/discount/" + discount, false); // false for synchronous request
        var res = xmlHttp.send(null);
    }

})

function disableSpaceButton(input) {
    input.on("keypress", function(e) {
        if (e.which == 32) {
            return false;
        }
    });
}

function trimVal(input) {
    var trimmed_value = input.val().trim();
    input.val(trimmed_value);
}

String.prototype.leftTrim = function() {
    return this.replace(/^\s+/, '');
}

function leftTrimVal(input) {
    var trimmed_value = input.val().leftTrim();
    input.val(trimmed_value);
}

function stripVal(input) {
    var stripped_value = input.val().replace(/\s/g, '');
    input.val('');
    input.val(stripped_value);
}
$(function() {
    $.fn.extend({
        triggerAll: function (events, params) {
            var el = this, i, evts = events.split(' ');
            for (i = 0; i < evts.length; i += 1) {
                el.trigger(evts[i], params);
            }
            return el;
        }
    });
});

function translateJudgemeBadge($element) {
    var $review_texts = $element.find('.jdgm-prev-badge__text');

    if ($review_texts.length) {
        var singular_review = "vélemény";
        var plural_review = "vélemény";

        $review_texts.each(function() {
            var review_content = $(this).text().trim().split(' ');
            var review_count = review_content[0];
            var translated_text = review_count > 1 ? plural_review : singular_review;
            var translated_content = review_count + ' ' + translated_text;

            $(this).text(translated_content);
        });
    }
}

function appendOptions(select, options) {
    let option_count = options.length;
    let options_html = '';

    for (let i = 0; i < option_count; i++) {
        const option = options[i];
        options_html += '<option value="' + option + '">' + option + "</option>";
    }

    select.append(options_html);
}

String.prototype.capitalizeFirstLetter = function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
}

if ($.validator) {
    $.validator.addMethod("validateSpamReg", function(value, element) {
        var spam_regex = RegExp('(www)|[\/!@#$€%?]|(.*\\d+.*)', 'ig');
        var regex_matches = spam_regex.test(value);

        return !regex_matches;
    }, "a formátum hibás".capitalizeFirstLetter());

    $.validator.addMethod('combinedMaxLength', function (value, element, params) {
        var combined_length = value.length + $(params.selector).val().length;
        var combined_max_length = params.maxLength || 60;

        return combined_length <= combined_max_length;
    },  'Túl hosszú név');

    $.validator.addMethod("notEqualToField", function(value, element, param) {
        return this.optional(element) || value != $(param).val();
    }, "Nem lehet ugyanaz".capitalizeFirstLetter());
}

function triggerCustomEvent(eventName) {
    $(document).trigger(eventName);
}

function initVivnetworks() {
    let vivnetwork_cj_event = getUrlVars()['cjevent'];

    if (vivnetwork_cj_event) {
        Cookies.set('cje', vivnetwork_cj_event, {expires: 120});
    }

}

function addValidatorRegexpMethod(name, error_msg)
{
    jQuery.validator.addMethod(
        name,
        function (value, element, regexp) {
            return new RegExp(regexp).test(value);
        },
        error_msg
    );
}

Shopify.handleize = function(str) {
    str = str.toLowerCase();

    var toReplace = ['"', '\'', '\\', '(', ')', '[', ']'];

    // For the old browsers
    for (var i = 0; i < toReplace.length; ++i) {
        str = str.replace(toReplace[i], '');
    }

    str = str.replace(/\W+/g, '-');

    if (str.charAt(str.length - 1) == '-') {
        str = str.replace(/-+\z/, '');
    }

    if (str.charAt(0) == '-') {
        str = str.replace(/\A-+/, '');
    }

    return str;
};

function isClientErrorCode(statusCode) {
    return statusCode && '4' === String(statusCode)[0];
}
